import React, { useEffect, useState } from "react";
import { createModel } from "hox";
import { TablePaginationConfig } from "antd/es/table";
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE, defaultMdCmParam } from "@/utils/constants";
import { ISearchPage } from "@/types/FmsTypes";
import { transPgToPagination } from "../../../../../base/app/appModel";
import { IBillDetail, IBIllFields, IBillSearch, IBillSearchParam, IBillSummary } from "../../../../../bill/BillTypes";
import { billService } from "../../../../../bill/BillService";
import { useDetailModel } from "../detailModel";
import { UserTypeEnum } from "@/types/FmsEnums";

export const useBillModel = createModel(function () {
    const initSearchParam: IBillSearchParam = {};
    const initDataSource: IBillDetail[] = [];
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }

    //查询条件
    const [searchParam, setSearchParam] = useState<IBillSearchParam>(initSearchParam);
    //列表数据源
    const [dataSource, setDataSource] = useState<IBillDetail[]>(initDataSource);
    //表格选中行Key值
    const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
    const [selectedData, setSelectedData] = useState<IBIllFields>();
    //列表数据源分页参数
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);

    const [billSummaryData, setBillSummaryData] = useState<IBillSummary>({});
    const [writeoffDrawerVisible, setWriteoffDrawerVisible] = useState(false);
    const { supplierCode } = useDetailModel();
    const [state, setstate] = useState(false)

    const onSearch = () => {
        loadData({ pageNum: 1 }).then()
    }
    const onReset = () => {
        resetSearchParam()
        setstate(!state)
    }


    const updatePgCfg = (updateParam: TablePaginationConfig) => {
        setPgCfg({ ...pgCfg, ...updateParam })
    }
    const updateSearchParam = (updateParam: IBIllFields) => {
        setSearchParam({ ...searchParam, ...updateParam })
    }
    const resetSearchParam = () => {
        setSearchParam(initSearchParam);
        setPgCfg(initPgCfg)
    }
    const clearSelectData = () => {
        setSelectedRowKeys([]);
        setSelectedData(undefined)
    }
    const loadData = async (page: ISearchPage = initPgCfg) => {
        const searchParams: IBillSearch = {
            ...searchParam,
            partnerCode: supplierCode,
            partnerTypeCode: UserTypeEnum.SUPPLIER,
            page: {
                pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
                pageNum: (page?.current || page?.pageNum) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
            }
        }
        let { retData } = await billService.page(searchParams);
        let { retData: billSummaryRetData } = await billService.billSummary(searchParams);
        const { records, ...pg } = retData;
        setPgCfg(transPgToPagination(pg));
        setBillSummaryData(billSummaryRetData)
        setDataSource(records);
        clearSelectData();
    }

    return {
        /***field***/
        state,
        searchParam,
        dataSource,
        selectedRowKeys,
        pgCfg,
        selectedData,
        writeoffDrawerVisible,
        billSummaryData,
        /***method***/
        setDataSource,
        setSelectedRowKeys,
        resetSearchParam,
        updateSearchParam,
        loadData,
        updatePgCfg,
        setWriteoffDrawerVisible,
        onSearch,
        onReset,
        setSelectedData,
    }
});
